export default __webpack_public_path__ + "static/media/mapColEpm2.e87d1fff.png";